module.exports = __webpack_public_path__ + "img/server1.d53bb257.svg";